var map = {
	"./PTO.svg": "./app/assets/statuses/PTO.svg",
	"./VTT.svg": "./app/assets/statuses/VTT.svg",
	"./acceleration.svg": "./app/assets/statuses/acceleration.svg",
	"./alarme.svg": "./app/assets/statuses/alarme.svg",
	"./alarmeEnd.svg": "./app/assets/statuses/alarmeEnd.svg",
	"./aux-0-off.svg": "./app/assets/statuses/aux-0-off.svg",
	"./aux-0.svg": "./app/assets/statuses/aux-0.svg",
	"./aux-1-highlight.svg": "./app/assets/statuses/aux-1-highlight.svg",
	"./aux-1-white-highlight.svg": "./app/assets/statuses/aux-1-white-highlight.svg",
	"./aux-1-white.svg": "./app/assets/statuses/aux-1-white.svg",
	"./aux-1.svg": "./app/assets/statuses/aux-1.svg",
	"./aux-12-highlight.svg": "./app/assets/statuses/aux-12-highlight.svg",
	"./aux-12-off.svg": "./app/assets/statuses/aux-12-off.svg",
	"./aux-12-white-highlight.svg": "./app/assets/statuses/aux-12-white-highlight.svg",
	"./aux-12.svg": "./app/assets/statuses/aux-12.svg",
	"./aux-123-highlight.svg": "./app/assets/statuses/aux-123-highlight.svg",
	"./aux-123-off.svg": "./app/assets/statuses/aux-123-off.svg",
	"./aux-123-white-highlight.svg": "./app/assets/statuses/aux-123-white-highlight.svg",
	"./aux-123.svg": "./app/assets/statuses/aux-123.svg",
	"./aux-1234-highlight.svg": "./app/assets/statuses/aux-1234-highlight.svg",
	"./aux-1234-off.svg": "./app/assets/statuses/aux-1234-off.svg",
	"./aux-1234-white-highlight.svg": "./app/assets/statuses/aux-1234-white-highlight.svg",
	"./aux-1234.svg": "./app/assets/statuses/aux-1234.svg",
	"./aux-124-highlight.svg": "./app/assets/statuses/aux-124-highlight.svg",
	"./aux-124-off.svg": "./app/assets/statuses/aux-124-off.svg",
	"./aux-124-white-highlight.svg": "./app/assets/statuses/aux-124-white-highlight.svg",
	"./aux-124.svg": "./app/assets/statuses/aux-124.svg",
	"./aux-13-highlight.svg": "./app/assets/statuses/aux-13-highlight.svg",
	"./aux-13-off.svg": "./app/assets/statuses/aux-13-off.svg",
	"./aux-13-white-highlight.svg": "./app/assets/statuses/aux-13-white-highlight.svg",
	"./aux-13.svg": "./app/assets/statuses/aux-13.svg",
	"./aux-134-highlight.svg": "./app/assets/statuses/aux-134-highlight.svg",
	"./aux-134-off.svg": "./app/assets/statuses/aux-134-off.svg",
	"./aux-134-white-highlight.svg": "./app/assets/statuses/aux-134-white-highlight.svg",
	"./aux-134.svg": "./app/assets/statuses/aux-134.svg",
	"./aux-14-highlight.svg": "./app/assets/statuses/aux-14-highlight.svg",
	"./aux-14-off.svg": "./app/assets/statuses/aux-14-off.svg",
	"./aux-14-white-highlight.svg": "./app/assets/statuses/aux-14-white-highlight.svg",
	"./aux-14.svg": "./app/assets/statuses/aux-14.svg",
	"./aux-2-highlight.svg": "./app/assets/statuses/aux-2-highlight.svg",
	"./aux-2-white-highlight.svg": "./app/assets/statuses/aux-2-white-highlight.svg",
	"./aux-2-white.svg": "./app/assets/statuses/aux-2-white.svg",
	"./aux-2.svg": "./app/assets/statuses/aux-2.svg",
	"./aux-23-highlight.svg": "./app/assets/statuses/aux-23-highlight.svg",
	"./aux-23-off.svg": "./app/assets/statuses/aux-23-off.svg",
	"./aux-23-white-highlight.svg": "./app/assets/statuses/aux-23-white-highlight.svg",
	"./aux-23.svg": "./app/assets/statuses/aux-23.svg",
	"./aux-234-highlight.svg": "./app/assets/statuses/aux-234-highlight.svg",
	"./aux-234-off.svg": "./app/assets/statuses/aux-234-off.svg",
	"./aux-234-white-highlight.svg": "./app/assets/statuses/aux-234-white-highlight.svg",
	"./aux-234.svg": "./app/assets/statuses/aux-234.svg",
	"./aux-24-highlight.svg": "./app/assets/statuses/aux-24-highlight.svg",
	"./aux-24-off.svg": "./app/assets/statuses/aux-24-off.svg",
	"./aux-24-white-highlight.svg": "./app/assets/statuses/aux-24-white-highlight.svg",
	"./aux-24.svg": "./app/assets/statuses/aux-24.svg",
	"./aux-3-highlight.svg": "./app/assets/statuses/aux-3-highlight.svg",
	"./aux-3-white-highlight.svg": "./app/assets/statuses/aux-3-white-highlight.svg",
	"./aux-3-white.svg": "./app/assets/statuses/aux-3-white.svg",
	"./aux-3.svg": "./app/assets/statuses/aux-3.svg",
	"./aux-34-highlight.svg": "./app/assets/statuses/aux-34-highlight.svg",
	"./aux-34-off.svg": "./app/assets/statuses/aux-34-off.svg",
	"./aux-34-white-highlight.svg": "./app/assets/statuses/aux-34-white-highlight.svg",
	"./aux-34.svg": "./app/assets/statuses/aux-34.svg",
	"./aux-4-highlight.svg": "./app/assets/statuses/aux-4-highlight.svg",
	"./aux-4-white-highlight.svg": "./app/assets/statuses/aux-4-white-highlight.svg",
	"./aux-4-white.svg": "./app/assets/statuses/aux-4-white.svg",
	"./aux-4.svg": "./app/assets/statuses/aux-4.svg",
	"./back-hoe.svg": "./app/assets/statuses/back-hoe.svg",
	"./backDoor.svg": "./app/assets/statuses/backDoor.svg",
	"./benne.svg": "./app/assets/statuses/benne.svg",
	"./button.svg": "./app/assets/statuses/button.svg",
	"./cell-connect-highlight.svg": "./app/assets/statuses/cell-connect-highlight.svg",
	"./cell-connect-white-highlight.svg": "./app/assets/statuses/cell-connect-white-highlight.svg",
	"./cell-connect-white.svg": "./app/assets/statuses/cell-connect-white.svg",
	"./cell-connect.svg": "./app/assets/statuses/cell-connect.svg",
	"./conveyor.svg": "./app/assets/statuses/conveyor.svg",
	"./deceleration.svg": "./app/assets/statuses/deceleration.svg",
	"./default-highlight.svg": "./app/assets/statuses/default-highlight.svg",
	"./default.svg": "./app/assets/statuses/default.svg",
	"./driverDoor.svg": "./app/assets/statuses/driverDoor.svg",
	"./engine-cut-highlight.svg": "./app/assets/statuses/engine-cut-highlight.svg",
	"./engine-cut-white-highlight.svg": "./app/assets/statuses/engine-cut-white-highlight.svg",
	"./engine-cut-white.svg": "./app/assets/statuses/engine-cut-white.svg",
	"./engine-cut.svg": "./app/assets/statuses/engine-cut.svg",
	"./engine-off.svg": "./app/assets/statuses/engine-off.svg",
	"./exceed.svg": "./app/assets/statuses/exceed.svg",
	"./exceedEnd.svg": "./app/assets/statuses/exceedEnd.svg",
	"./fast-acc-highlight.svg": "./app/assets/statuses/fast-acc-highlight.svg",
	"./fast-acc-white-highlight.svg": "./app/assets/statuses/fast-acc-white-highlight.svg",
	"./fast-acc-white.svg": "./app/assets/statuses/fast-acc-white.svg",
	"./fast-acc.svg": "./app/assets/statuses/fast-acc.svg",
	"./fast-dec-highlight.svg": "./app/assets/statuses/fast-dec-highlight.svg",
	"./fast-dec-white-highlight.svg": "./app/assets/statuses/fast-dec-white-highlight.svg",
	"./fast-dec-white.svg": "./app/assets/statuses/fast-dec-white.svg",
	"./fast-dec.svg": "./app/assets/statuses/fast-dec.svg",
	"./forklift.svg": "./app/assets/statuses/forklift.svg",
	"./fourDoors.svg": "./app/assets/statuses/fourDoors.svg",
	"./frontPlow.svg": "./app/assets/statuses/frontPlow.svg",
	"./garbageBin.svg": "./app/assets/statuses/garbageBin.svg",
	"./gear-red.svg": "./app/assets/statuses/gear-red.svg",
	"./generator.svg": "./app/assets/statuses/generator.svg",
	"./green-arrow-highlight.svg": "./app/assets/statuses/green-arrow-highlight.svg",
	"./green-arrow-up-highlight.svg": "./app/assets/statuses/green-arrow-up-highlight.svg",
	"./green-arrow-up-white-highlight.svg": "./app/assets/statuses/green-arrow-up-white-highlight.svg",
	"./green-arrow-up-white.svg": "./app/assets/statuses/green-arrow-up-white.svg",
	"./green-arrow-up.svg": "./app/assets/statuses/green-arrow-up.svg",
	"./green-arrow-white-highlight.svg": "./app/assets/statuses/green-arrow-white-highlight.svg",
	"./green-arrow-white.svg": "./app/assets/statuses/green-arrow-white.svg",
	"./green-arrow.svg": "./app/assets/statuses/green-arrow.svg",
	"./green-gear-highlight.svg": "./app/assets/statuses/green-gear-highlight.svg",
	"./green-gear-white-highlight.svg": "./app/assets/statuses/green-gear-white-highlight.svg",
	"./green-gear-white.svg": "./app/assets/statuses/green-gear-white.svg",
	"./green-gear.svg": "./app/assets/statuses/green-gear.svg",
	"./grove.svg": "./app/assets/statuses/grove.svg",
	"./identification.svg": "./app/assets/statuses/identification.svg",
	"./impact-alert-highlight.svg": "./app/assets/statuses/impact-alert-highlight.svg",
	"./impact-alert-white-highlight.svg": "./app/assets/statuses/impact-alert-white-highlight.svg",
	"./impact-alert-white.svg": "./app/assets/statuses/impact-alert-white.svg",
	"./impact-alert.svg": "./app/assets/statuses/impact-alert.svg",
	"./keyStart.svg": "./app/assets/statuses/keyStart.svg",
	"./loader.svg": "./app/assets/statuses/loader.svg",
	"./low-power-highlight.svg": "./app/assets/statuses/low-power-highlight.svg",
	"./low-power-white-highlight.svg": "./app/assets/statuses/low-power-white-highlight.svg",
	"./low-power-white.svg": "./app/assets/statuses/low-power-white.svg",
	"./low-power.svg": "./app/assets/statuses/low-power.svg",
	"./max-speed-highlight.svg": "./app/assets/statuses/max-speed-highlight.svg",
	"./max-speed-white-highlight.svg": "./app/assets/statuses/max-speed-white-highlight.svg",
	"./max-speed-white.svg": "./app/assets/statuses/max-speed-white.svg",
	"./max-speed.svg": "./app/assets/statuses/max-speed.svg",
	"./min-speed-highlight.svg": "./app/assets/statuses/min-speed-highlight.svg",
	"./min-speed-white-highlight.svg": "./app/assets/statuses/min-speed-white-highlight.svg",
	"./min-speed-white.svg": "./app/assets/statuses/min-speed-white.svg",
	"./min-speed.svg": "./app/assets/statuses/min-speed.svg",
	"./minivan.svg": "./app/assets/statuses/minivan.svg",
	"./multiple_vehicles-highlight.svg": "./app/assets/statuses/multiple_vehicles-highlight.svg",
	"./multiple_vehicles-white-highlight.svg": "./app/assets/statuses/multiple_vehicles-white-highlight.svg",
	"./multiple_vehicles-white.svg": "./app/assets/statuses/multiple_vehicles-white.svg",
	"./multiple_vehicles.svg": "./app/assets/statuses/multiple_vehicles.svg",
	"./navigation-arrow-rotate-square.svg": "./app/assets/statuses/navigation-arrow-rotate-square.svg",
	"./nonAutorise.svg": "./app/assets/statuses/nonAutorise.svg",
	"./orange-cloud-highlight.svg": "./app/assets/statuses/orange-cloud-highlight.svg",
	"./orange-cloud.svg": "./app/assets/statuses/orange-cloud.svg",
	"./orange-odometer-highlight.svg": "./app/assets/statuses/orange-odometer-highlight.svg",
	"./orange-odometer.svg": "./app/assets/statuses/orange-odometer.svg",
	"./outside-network-highlight.svg": "./app/assets/statuses/outside-network-highlight.svg",
	"./outside-network-white-highlight.svg": "./app/assets/statuses/outside-network-white-highlight.svg",
	"./outside-network-white.svg": "./app/assets/statuses/outside-network-white.svg",
	"./outside-network.svg": "./app/assets/statuses/outside-network.svg",
	"./passengerDoor.svg": "./app/assets/statuses/passengerDoor.svg",
	"./paver.svg": "./app/assets/statuses/paver.svg",
	"./person.svg": "./app/assets/statuses/person.svg",
	"./personalButton.svg": "./app/assets/statuses/personalButton.svg",
	"./professionalButton.svg": "./app/assets/statuses/professionalButton.svg",
	"./prolonged-highlight.svg": "./app/assets/statuses/prolonged-highlight.svg",
	"./prolonged-idle-highlight.svg": "./app/assets/statuses/prolonged-idle-highlight.svg",
	"./prolonged-idle-white-highlight.svg": "./app/assets/statuses/prolonged-idle-white-highlight.svg",
	"./prolonged-idle-white.svg": "./app/assets/statuses/prolonged-idle-white.svg",
	"./prolonged-idle.svg": "./app/assets/statuses/prolonged-idle.svg",
	"./recycle.svg": "./app/assets/statuses/recycle.svg",
	"./red-hand-highlight.svg": "./app/assets/statuses/red-hand-highlight.svg",
	"./red-hand-white-highlight.svg": "./app/assets/statuses/red-hand-white-highlight.svg",
	"./red-hand-white.svg": "./app/assets/statuses/red-hand-white.svg",
	"./red-hand.svg": "./app/assets/statuses/red-hand.svg",
	"./reverse.svg": "./app/assets/statuses/reverse.svg",
	"./roller.svg": "./app/assets/statuses/roller.svg",
	"./seatbelts.svg": "./app/assets/statuses/seatbelts.svg",
	"./semi-trailer.svg": "./app/assets/statuses/semi-trailer.svg",
	"./sidePlow.svg": "./app/assets/statuses/sidePlow.svg",
	"./sirens.svg": "./app/assets/statuses/sirens.svg",
	"./smokeDetector.svg": "./app/assets/statuses/smokeDetector.svg",
	"./snow-plow.svg": "./app/assets/statuses/snow-plow.svg",
	"./speed-highlight.svg": "./app/assets/statuses/speed-highlight.svg",
	"./speed-white-highlight.svg": "./app/assets/statuses/speed-white-highlight.svg",
	"./speed-white.svg": "./app/assets/statuses/speed-white.svg",
	"./speed.svg": "./app/assets/statuses/speed.svg",
	"./starHighlight.svg": "./app/assets/statuses/starHighlight.svg",
	"./startButton.svg": "./app/assets/statuses/startButton.svg",
	"./stopped-highlight.svg": "./app/assets/statuses/stopped-highlight.svg",
	"./stopped-white-highlight.svg": "./app/assets/statuses/stopped-white-highlight.svg",
	"./stopped-white.svg": "./app/assets/statuses/stopped-white.svg",
	"./stopped.svg": "./app/assets/statuses/stopped.svg",
	"./telephone.svg": "./app/assets/statuses/telephone.svg",
	"./temp-alert-highlight.svg": "./app/assets/statuses/temp-alert-highlight.svg",
	"./temp-alert-white-highlight.svg": "./app/assets/statuses/temp-alert-white-highlight.svg",
	"./temp-alert-white.svg": "./app/assets/statuses/temp-alert-white.svg",
	"./temp-alert.svg": "./app/assets/statuses/temp-alert.svg",
	"./temperature.svg": "./app/assets/statuses/temperature.svg",
	"./theft-alert-end-highlight.svg": "./app/assets/statuses/theft-alert-end-highlight.svg",
	"./theft-alert-end-white-highlight.svg": "./app/assets/statuses/theft-alert-end-white-highlight.svg",
	"./theft-alert-end-white.svg": "./app/assets/statuses/theft-alert-end-white.svg",
	"./theft-alert-end.svg": "./app/assets/statuses/theft-alert-end.svg",
	"./theft-alert-highlight.svg": "./app/assets/statuses/theft-alert-highlight.svg",
	"./theft-alert-white-highlight.svg": "./app/assets/statuses/theft-alert-white-highlight.svg",
	"./theft-alert-white.svg": "./app/assets/statuses/theft-alert-white.svg",
	"./theft-alert.svg": "./app/assets/statuses/theft-alert.svg",
	"./truck-tractor.svg": "./app/assets/statuses/truck-tractor.svg",
	"./truck-trash.svg": "./app/assets/statuses/truck-trash.svg",
	"./truck.svg": "./app/assets/statuses/truck.svg",
	"./vehicle-green-highlight.svg": "./app/assets/statuses/vehicle-green-highlight.svg",
	"./vehicle-green.svg": "./app/assets/statuses/vehicle-green.svg",
	"./vehicle-white-highlight.svg": "./app/assets/statuses/vehicle-white-highlight.svg",
	"./vehicle-white.svg": "./app/assets/statuses/vehicle-white.svg",
	"./vehicle.svg": "./app/assets/statuses/vehicle.svg",
	"./vehicleIcon-default.svg": "./app/assets/statuses/vehicleIcon-default.svg",
	"./weight-highlight.svg": "./app/assets/statuses/weight-highlight.svg",
	"./weight-white-highlight.svg": "./app/assets/statuses/weight-white-highlight.svg",
	"./weight-white.svg": "./app/assets/statuses/weight-white.svg",
	"./weight.svg": "./app/assets/statuses/weight.svg",
	"./white-arrow-highlight.svg": "./app/assets/statuses/white-arrow-highlight.svg",
	"./white-arrow.svg": "./app/assets/statuses/white-arrow.svg",
	"./white-cloud-highlight.svg": "./app/assets/statuses/white-cloud-highlight.svg",
	"./white-cloud.svg": "./app/assets/statuses/white-cloud.svg",
	"./white-odometer-highlight.svg": "./app/assets/statuses/white-odometer-highlight.svg",
	"./white-odometer.svg": "./app/assets/statuses/white-odometer.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/statuses sync recursive .svg$";